import { type LocalApp, useApplication } from 'ApplicationContext';
import type { ReactElement } from 'react';
import { type IndexRouteObject, Navigate } from 'react-router';

export const createIndexRoute = (path: string): IndexRouteObject => ({
  index: true,
  element: <Navigate to={path} replace />,
});

const IndexComponent = ({ paths }: { paths: Record<LocalApp, string> }): ReactElement => {
  const { app } = useApplication();
  return <Navigate to={paths[app]} replace />;
};

export const createAppIndexRoute = (paths: Record<LocalApp, string>): IndexRouteObject => {
  return {
    index: true,
    element: <IndexComponent paths={paths} />,
  };
};
